<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-align-justify" titulo="RESUMO DA PRODUÇÃO">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Lote: <strong class="text-white">{{ registro.LOTE || '---' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-calendar mr-1 text-info"></i>
        Data: <strong class="text-white">{{ registro.DATA ? moment(registro.DATA).format('DD/MM/YYYY') : '---' }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="exibirBotaoAlterar" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="onGravarEditar()">
          <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÕES
        </b-button>

        <b-button v-if="exibirBotaoGravar" variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="onGravarNovo()">
          <i class="fa fa-save mr-1"></i> GRAVAR
        </b-button>

        <b-button v-if="exibirBotaoFinalizar" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="onFinalizar(true)">
          <i class="fa fa-check mr-1"></i> LIBERAR TERMINAL
        </b-button>

        <b-button v-if="exibirBotaoReabrir" variant="link" class="btn-glass btn-glass-info" @click="onReabrir()">
          <i class="fa fa-unlock mr-1"></i> REABRIR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="onVoltarPrincipal()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <div style="max-height: 85vh; overflow-y: auto; overflow-x: hidden;" class="pr-2">
        <!-- Main Summary Bar -->
        <b-row class="mb-4 mt-2">
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Código ID</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.ID || '---'}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Data Cadastro</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.DT_LANCAMENTO ? moment(registro.DT_LANCAMENTO).format('DD/MM/YYYY') : '---'}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Situação</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{traduzStatus}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-success" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">TOTAL PESO (KG)</small>
              <h2 class="mb-0 font-weight-bold text-dark">{{tabelaAnimais.items.reduce((acc, item) => acc + (item.QUANT || 0), 0).toLocaleString('pt-BR', {minimumFractionDigits: 2})}}</h2>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6">
            <!-- Identificação Básica -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-info-circle mr-2'></i>Identificação Básica
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Data do Resumo" label-class="modal-label-premium">
                      <cec-input-data v-model="registro.DATA" :disabled="desabilitarQuandoFechado" :state="registro.DATA != null" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Tipo de Fechamento" label-class="modal-label-premium">
                      <b-form-select v-model="registro.OP_TIPO" :options="tipoFechamento" :disabled="!desabilitarSeTemItem || desabilitarQuandoFechado" :state="registro.OP_TIPO != null" class="rounded-pill shadow-xs"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Lote" label-class="modal-label-premium">
                      <b-form-input type="text" v-model="registro.LOTE" :disabled="desabilitarQuandoFechado" :state="registro.LOTE != null" placeholder="Informe o Lote" class="rounded-pill shadow-xs"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <ordem-abate-fechada-pesquisa 
                      @retornaId="registro.ABATE_ID = $event"
                      :idInicial="registro.ABATE_ID"
                      :classe-required="registro.ABATE_ID == null && desabilitarAbate"
                      :desabilitarInput="desabilitarQuandoFechado || desabilitarAbate"
                      idModal="ordemAbate"
                      label="Ordem Abate Fechada"
                      id="edABATE_ID"
                      place="Informe a Ordem de Abate"
                      :arredondado="true"
                      labelBotao="">
                    </ordem-abate-fechada-pesquisa>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col lg="6">
            <!-- Interessados e Endereçamento -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-users mr-2'></i>Interessados e Endereçamento
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Responsável" label-class="modal-label-premium">
                      <FuncionarioDropdown 
                        v-model="registro.BALANCEIRO_ID"
                        :disabled="desabilitarQuandoFechado"
                        :state="registro.BALANCEIRO_ID != null"
                        placeholder="Selecione o Responsável"
                        class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <b-form-group label="Estoque de Destino" label-class="modal-label-premium">
                      <CentroEstoqueDropDown 
                        v-model="registro.CENTRO_ESTOQUE_ID"
                        :disabled="!desabilitarSeTemItem"
                        :state="registro.CENTRO_ESTOQUE_ID != null"
                        placeholder="Informe Estoque de Destino"
                        class="rounded-pill shadow-xs"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <!-- Acumulados -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg overflow-hidden">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-calculator mr-2'></i>Resumo de Acumulados (Totais por Produto)
                </h5>
              </div>
              <b-card-body class="p-0">
                <b-table 
                  class="modern-premium-table mb-0" 
                  hover 
                  responsive
                  :items="tabelaDetalhes.items" 
                  :fields="tabelaDetalhes.fields"
                  show-empty
                  empty-text="Nenhum acumulado disponível"
                ></b-table>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <!-- Produtos Beneficiados -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg overflow-hidden">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-cube mr-2'></i>Produtos Beneficiados (Lançamentos Detalhados)
                </h5>
                <!--
                <div class="d-flex gap-2">
                  <b-button v-if="registro.ID < 1" variant="success" pill size="sm" class="shadow-sm font-weight-bold px-3" @click.stop.prevent="onIniciarCadastramento()" :disabled="desabilitarQuandoFechado">
                    <i class="fa fa-plus mr-1"></i> Incluir Produto
                  </b-button>
                  <b-button v-else variant="success" pill size="sm" class="shadow-sm font-weight-bold px-3" @click.stop.prevent="onAbrirmodalProduto()" :disabled="desabilitarQuandoFechado">
                    <i class="fa fa-plus mr-1"></i> Incluir Produto
                  </b-button>
                </div>
                -->
              </div>
              <b-card-body class="p-0">
                <b-table 
                  class="modern-premium-table mb-0" 
                  hover 
                  responsive
                  sticky-header="400px"
                  :items="tabelaAnimais.items" 
                  :fields="tabelaAnimais.fields"
                  show-empty
                  empty-text="Nenhum produto lançado"
                >
                  <template #cell(actions)="item">
                    <div class="d-flex gap-1 justify-content-end">
                      <b-button type="button" @click="onDeleteAnimal(item.item)" :disabled="desabilitarQuandoFechado" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Remover Animal" v-b-tooltip.hover>
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Modal Produto Modernizado -->
    <b-modal ref="modal-produto" 
        id="modal-produto" 
        hide-header
        hide-footer
        centered
        size="lg"
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        @shown="focusModalProduto()" 
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-cube text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">Cadastrar Produto</h5>
              <small class="text-white opacity-75">Lançamento de produtos beneficiados no resumo</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-produto')">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
          <b-row>
            <b-col sm="12">
              <produto-pesquisa 
                @retornaId="animal.PRODUTO_ID = $event"
                :idInicial="animal.PRODUTO_ID"
                :classe-required="animal.PRODUTO_ID == null"
                id="edPRODUTO_ID"
                ref="edPRODUTO_ID"
                idModal="modalProduto"
                label="Produto"
                place="Informe Produto"
                :arredondado="true"
                labelBotao="">
              </produto-pesquisa>
            </b-col>
          </b-row>
          
          <b-row class="mt-3">  
            <b-col sm="6">
              <b-form-group label="Quantidade KG" label-class="modal-label-premium">
                <vue-autonumeric v-model="animal.QUANT" 
                  :options="{
                    digitGroupSeparator: '.',
                    decimalCharacter: ',',
                    decimalCharacterAlternative: '.',
                    roundingMethod: 'U',
                    minimumValue: '0'
                  }"
                  :class="['form-control rounded-pill shadow-xs', {
                    'is-valid' : animal.QUANT > 0,
                    'is-invalid' : animal.QUANT <= 0
                  }]">
                </vue-autonumeric>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Peças" label-class="modal-label-premium">
                <vue-autonumeric v-model="animal.PECAS" 
                  :options="{
                    digitGroupSeparator: '.',
                    decimalCharacter: ',',
                    decimalCharacterAlternative: '.',
                    decimalPlaces: '0',
                    roundingMethod: 'U',
                    minimumValue: '0'
                  }"
                  :class="['form-control rounded-pill shadow-xs', {
                    'is-valid' : animal.PECAS > 0,
                    'is-invalid' : animal.PECAS <= 0
                  }]">
                </vue-autonumeric>
              </b-form-group>
            </b-col>
          </b-row>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold mr-2" @click="$bvModal.hide('modal-produto')">
              CANCELAR
          </b-button>
          <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="onPostProduto()">
              <i class="fa fa-save mr-1"></i> GRAVAR PRODUTO
          </b-button>
      </div>
    </b-modal>

    <!-- Modal Reabrir Planejamento -->
    <b-modal ref="modal-reabrir" 
        id="modal-reabrir" 
        hide-header
        hide-footer
        centered
        size="lg"
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        @shown="focusModalReabrir()" 
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-unlock text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">Reabrir Planejamento</h5>
              <small class="text-white opacity-75">Informe o motivo da reabertura</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-reabrir')">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
          <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
              <div class="d-flex align-items-center">
                  <div class="avatar-circle mr-3 bg-warning text-white">
                      <i class="fa fa-tag"></i>
                  </div>
                  <div>
                      <small class="text-muted d-block">ID do Registro</small>
                      <span class="font-weight-bold text-dark">{{registro.ID}}</span>
                  </div>
              </div>
              <div class="text-right">
                  <small class="text-muted d-block">Status Atual</small>
                  <b-badge pill variant="info">{{traduzStatus}}</b-badge>
              </div>
          </div>

          <div class="alert alert-soft-warning border-0">
              <i class="fa fa-info-circle mr-2"></i>
              <strong>Atenção:</strong> Ao reabrir, os campos serão liberados para edição e o status voltará ao estado anterior.
          </div>

          <b-form-group label="Motivo da Reabertura" label-class="modal-label-premium">
              <b-form-textarea 
                ref="edMotivoReabrir" 
                id="edMotivoReabrir" 
                v-model="motivoReabrir"
                placeholder="Descreva o motivo da reabertura do planejamento..." 
                :state="motivoReabrir && motivoReabrir.trim().length > 0"
                rows="4"
                class="rounded shadow-xs">
              </b-form-textarea>
          </b-form-group>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-secondary" pill class="px-4 font-weight-bold mr-2" @click="$bvModal.hide('modal-reabrir')">
              CANCELAR
          </b-button>
          <b-button variant="warning" pill class="px-5 font-weight-bold shadow-sm text-white" @click="confirmarReabrir()" :disabled="!motivoReabrir || motivoReabrir.trim().length === 0">
              <i class="fa fa-unlock mr-1"></i> CONFIRMAR REABERTURA
          </b-button>
      </div>
    </b-modal>
  </div>
</template>
  


<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import CentroEstoqueDropDown from '../../componentes/dropdown/CentroEstoqueDropDown.vue'
import OrdemAbateFechadaPesquisa from '../../pesquisa/OrdemAbateFechadaPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'

export default {
  components: {
    VueButtonSpinner,
    FuncionarioDropdown,
    CentroEstoqueDropDown,
    OrdemAbateFechadaPesquisa,
    ProdutoPesquisa,
    HeaderPadrao,
    CecInputData,
    VueAutonumeric
  },
  data () {
    return {
      moment: moment,
      isLoading: false,
      status: '',
      submmited: false,
      alterandoCadastro: false,
      registroOriginal: {},
      itensForamAlterados: false,
      processoPorTerminal: '0',
      parametrosSistema: null,
      registro: {
        ID                : null,
        BALANCEIRO_ID     : null,
        DATA              : null,
        DT_LANCAMENTO     : null,
        USUARIO           : null,
        DT_ALTERACAO      : null,
        USUARIO_ALTERACAO : null,
        OBS               : null,
        STATUS            : null,
        CENTRO_ESTOQUE_ID : null,
        OP_TIPO           : null,
        ABATE_ID          : null,
        LOTE              : null,
      },
      animal: {
        ID: null,
        INDICE: null,
        ABATE_RESUMO_ID: null,
        PRODUTO_ID : null,
        QUANT: 0.00,
        PECAS: null,
        VALIDADE: null,
        DATA_VALIDADE: null,
        OP_MANUAL: null,
        OP_STATUS: null
      },
      tipoFechamento: [
        {value: '0', text: '0 - FECHAMENTO DIARIO'},
        {value: '1', text: '1 - FECHAMENTO DO LOTE'}
      ],
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      tabelaAnimais: {
        fields: [
          {
            key: "INDICE",
            label: 'Item'
          },
          {
            key: "DESCRICAO",
            label: 'Produto'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right',
            thStyle: { width: "10%" }
          }
        ],
        items: []
      },
      tabelaDetalhes: {
        fields: [
          {
            key: "DESCRICAO",
            label: 'Produto'
          },
          {
            key: "PESOS",
            label: 'Itens'
          },
          {
            key: 'QUANT', 
            class:'text-right', 
            label: 'Peso (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: 'MEDIA', 
            class:'text-right', 
            label: 'Media (KG)', 
            formatter: (value, key, item) => 
            value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : (0.00).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          }
        ],
        items: []
      },
         
      optionsRaca: [],
      optionsCor: [],
      optionsSexo: [
       {value: 'M', text: 'MACHO'},
       {value: 'F', text: 'FEMEA'}
      ],
      motivoReabrir: null
      
    }
  },
  methods: {
    isValid() {
      return     this.registro.DATA 
              && this.registro.OP_TIPO
              && this.registro.BALANCEIRO_ID
              && this.registro.CENTRO_ESTOQUE_ID
              && this.registro.LOTE
              && ( (this.registro.OP_TIPO == '0' && !this.registro.ABATE_ID ) || 
                   (this.registro.OP_TIPO == '1' && this.registro.ABATE_ID ))
    },
    isValidaAnimal() {
      return     this.animal.PRODUTO_ID
              && this.animal.PECAS
    },
    async onVoltarPrincipal() {
      
        this.$router.push('/producao/resumo/listagem')
        this.$store.commit("abateResumo/SET_REGISTRO_SELECIONADO_ID", this.registro.ID?? 0)
      
    },
    onAbrirmodalProduto() {
      this.limparObjeto(this.animal)
      this.animal.QUANT = 0.00

      this.$refs['modal-produto'].show()
    },
    focusModalProduto (){
      this.$refs.edPRODUTO_ID.$refs.auto.$refs.autocomplete.focus()
    },
    async onPostProduto () {
      if (!this.isValidaAnimal()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      } else {
        this.$store.commit('controle/setAguardando', true)   
        let gravouAnimal = await this.gravarNovoProduto()
        if (gravouAnimal == true) {
          let atualizouListaAnimal = await this.atualizarListaProduto()
          if (atualizouListaAnimal) {
            if (await this.atualizarListaProduto()) {
              if (await this.atualizarListaDetalhe()) {
                this.$refs['modal-produto'].hide()
                this.$store.commit('controle/setAguardando', false)
              } else {
                this.$store.commit('controle/setAguardando', false)   
              }
            } else {
              this.$store.commit('controle/setAguardando', false)   
            }
            
          } else {
            this.$store.commit('controle/setAguardando', false)   
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
        }
      } 
    },
    gravarNovoProduto () {
      this.animal.ABATE_RESUMO_ID = this.registro.ID
      return new Promise(resolve => {
        this.$http.post(`/api/protected/producao/resumo/item/postWeb`, this.animal)
        .then(() =>{
          this.itensForamAlterados = true
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaProduto () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getViewPesagem/${this.registro.ID}`)
        .then(result =>{
          this.tabelaAnimais.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    atualizarListaDetalhe () {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getViewDetalhe/${this.registro.ID}`)
        .then(result =>{
          this.tabelaDetalhes.items = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async onDeleteAnimal (item) {
      this.$store.commit('controle/setAguardando', true)   
      if (await this.excluirProduto(item) == true) {
        if (await this.atualizarListaProduto() == true) {
          if (await this.atualizarListaDetalhe() == true) {
            this.$refs['modal-produto'].hide()
          } else {
            this.$store.commit('controle/setAguardando', false)   
            return
          }
        } else {
          this.$store.commit('controle/setAguardando', false)   
          return
        }
      } else {
        this.$store.commit('controle/setAguardando', false)   
        return
      }

      this.$store.commit('controle/setAguardando', false)

      this.toastCount++
      this.$root.$bvToast.toast(`Animal removido da lista de Ordem de Abate`, {
        title: 'Atenção',
        autoHideDelay: 3000,
        variant: 'success',
        appendToast: true
      })
      this.itensForamAlterados = true
      
    },
    excluirProduto (item) {
      
      return new Promise(resolve => {
        this.$http.post(`/api/protected/producao/resumo/item/deleteWeb/${item.ID}`)
        .then(() =>{
          resolve(true)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
    },
    async onGravarNovo () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      if (this.tabelaAnimais.items && this.tabelaAnimais.items.length > 0 ) {
        this.registro.STATUS = '2' // Planejamento Iniciado
      } else {
        this.registro.STATUS = '1' //lancamentos principais
      }

      this.registro.USUARIO = window.localStorage.getItem('login')
      
      try {
        this.$store.commit('controle/setAguardando', true) 
        let response = null
        try {
          response = await this.$http.post(`/api/protected/producao/resumo/post`, this.registro)
        } catch (err) {
           Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
           return
        }
        this.registro = response.data?? null
        if (!this.registro) {
          console.log('Nao retornou o post')
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível. Tente novamente!' )
          return
        } 
        this.registroOriginal = JSON.parse(JSON.stringify(this.registro)) // deep clone seguro

        Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido gravado com sucesso` )
        
        // Atualiza a URL para o modo de edição
        this.$router.replace(`/producao/resumo/edit/${this.registro.ID}`)
        
        await this.iniciarAlteracao(this.registro.ID)
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
        
    },
    async onGravarEditar () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)    
        try {
          await this.$http.post(`/api/protected/producao/resumo/edit`, this.registro)
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido alterado com sucesso` )

          this.registroOriginal = JSON.parse(JSON.stringify(this.registro)) // deep clone seguro

        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        this.$store.dispatch('abateResumo/GERAR_LISTA')
      } finally {
        this.$store.commit('controle/setAguardando', false)    
        return
      }
      
    },
    async onFinalizar () {
      if (!this.isValid()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todos os campos obrigatórios!!!` )
        return
      }
      

      const resposta = await this.$bvModal.msgBoxConfirm(`Liberar o Pedido para o Terminal ?`, {
        title: 'Liberar?',
        size: 'lg',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (resposta == false) {
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)    
        try {
          await this.$http.post(`/api/protected/producao/resumo/finalizar/`, this.registro)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        await this.$store.dispatch('abateResumo/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', `Pedido enviado ao Terminal!!!` )
        this.$router.push('/producao/resumo/listagem')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onReabrir() {
      // Abre o modal para solicitar o motivo
      this.motivoReabrir = null
      this.$refs['modal-reabrir'].show()
    },
    focusModalReabrir() {
      this.$nextTick(() => {
        if (this.$refs.edMotivoReabrir) {
          this.$refs.edMotivoReabrir.focus()
        }
      })
    },
    async confirmarReabrir() {
      if (!this.motivoReabrir || this.motivoReabrir.trim() === '') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o motivo da reabertura!')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const payload = {
          id: this.registro.ID,
          motivo: this.motivoReabrir.trim(),
          usuario: window.localStorage.getItem('login')
        }

        await this.$http.post(`/api/protected/producao/resumo/reabrirPlanejamento`, payload)
        
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Planejamento reaberto com sucesso!')
        this.$refs['modal-reabrir'].hide()
        
        // Recarrega o registro para atualizar o status
        await this.iniciarAlteracao(this.registro.ID)
      } catch (err) {
        const mensagemErro = err.response?.data || err.message || 'Erro ao reabrir planejamento'
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', mensagemErro)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    onIniciarCadastramento () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      this.registro.USUARIO = window.localStorage.getItem('login')
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/resumo/post`, this.registro)
        .then((result) => {
          console.log(result.data)
          this.registro.ID = result.data[0].ID
          
          this.registroOriginal = JSON.parse(JSON.stringify(this.registro))
          this.alterandoCadastro = true

          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          this.$root.$bvToast.toast(`Dadas inicias cadastrados!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
        })
        .then(() => {
          this.onAbrirmodalProduto()
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
        })
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/resumo/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      let reg = await this.getRegistroById(id)
      if (reg == null) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.push('/producao/resumo/listagem')
        return
      }
      
      //reg.data[0].DATA = moment(new Date(reg.data[0].DATA)).format('YYYY-MM-DD')
      //reg.data[0].DT_LANCAMENTO = moment(new Date(reg.data[0].DT_LANCAMENTO)).format('YYYY-MM-DD')
      reg.data[0].DATA = Tools.formatarDataParaInput(reg.data[0].DATA)
      reg.data[0].DT_LANCAMENTO = Tools.formatarDataParaInput(reg.data[0].DT_LANCAMENTO)
      

      this.registro = reg.data[0]
      
      this.tabelaAnimais.items = []

      if (await this.atualizarListaProduto() == true) {
        

      } else {
        this.$store.commit('controle/setAguardando', false)
        this.$router.push('/producao/resumo/listagem')
        return
      }

      if (await this.atualizarListaDetalhe() == true) {
        

      } else {
        this.$store.commit('controle/setAguardando', false)
        this.$router.push('/producao/resumo/listagem')
        return
      }
   
      //CONTROLA ALTERACOES PARA O BOTAO ALTERAR
      this.registroOriginal = JSON.parse(JSON.stringify(this.registro))
      this.alterandoCadastro = true
      this.itensForamAlterados = false

      
      this.$store.commit('controle/setAguardando', false)
      return
      
    },
    compararObjeto (obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2)
    },
    limparObjeto (a) {
      let prop1 = Object.getOwnPropertyNames(a)
      for(var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) ) {
          a[prop] = null
        }
      }
    },
    async carregarParametrosSistema() {
      try {
        let parametrosResult = await this.$http.get(`/api/protected/parametro/getParametrosResumoAbate`)
        this.parametrosSistema = parametrosResult.data?.[0]
      } catch (err) {
        console.log('Erro ao carregar os parametros do sistema ' + err)
      }
    }
  },
  async created () {
    try {
      // nao monitorar o botao gravar
      this.alterandoCadastro = false
      
      let id = this.$route.params.id

      try {
        //ALTERACAO
        if ( id ) {
          try {
            await this.iniciarAlteracao(id)
            this.registroOriginal = JSON.parse(JSON.stringify(this.registro)) // deep clone seguro
          } catch (err) {
            console.log(err)
            throw (err)
          }
        }
      
        //NOVO REGISTRO
        else {
          this.registro.DATA                      = Tools.getDataAtual()
          this.registro.DT_LANCAMENTO             = Tools.getDataAtual()
          this.registro.OP_TIPO                   = '0'
          this.registroOriginal = JSON.parse(JSON.stringify(this.registro)) // deep clone seguro

          this.tabelaAnimais.items = []
          this.tabelaDetalhes.items = []

        }
      } catch (err) {
        console.log(err)
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.push('/producao/resumo/listagem')
        return
      }
    } finally {
      this.$store.commit('controle/setAguardando', false)
    } 
  },
  computed: {
    exibirBotaoLiberarPorTerminal: function() {
      return (['2','3','4'].includes(this.registro.STATUS)) ? false : true
    },
    exibirBotaoAlterar: function() {
      if (this.alterandoCadastro == true) {
        return   !this.compararObjeto(this.registro, this.registroOriginal)
      } else {
        return false
      }
    },
    exibirBotaoGravar: function () {
      if (this.alterandoCadastro == false) {
        return   !this.compararObjeto(this.registro, this.registroOriginal)
      } else {
        return false
      }
    },
    exibirBotaoFinalizar: function() {
      if (this.alterandoCadastro == true) {
        return   this.compararObjeto(this.registro, this.registroOriginal) && this.registro.ID > 0 && this.registro.STATUS =='0'
             // ||  this.itensForamAlterados
      } else {
        return false
      }
    },
    exibirBotaoReabrir :function() {
      return (['1','3','4']).includes(this.registro.STATUS)  ? true : false
    },
    traduzStatus : function () {
      if (this.registro.STATUS == null) return 'EM CADASTRO'
      switch (this.registro.STATUS) {
        case  '0' : return 'EM CADASTRO'
        case  '1' : return 'PRONTO PRA COLETA' 
        case  '2' : return 'EXCLUIDO' 
        case  '3' : return 'EM COLETA' 
        case  '4' : return 'FINALIZADO' 
        default:
          break;
      }
    },
    desabilitarAbate: function () {
      return this.registro.OP_TIPO == '0'
    },
    desabilitarSeTemItem: function () {
      return this.tabelaAnimais.items.length === 0
    },
    desabilitarQuandoFechado: function () {
      // Desabilita campos quando status for diferente de '0' (EM CADASTRO)
      return this.registro.STATUS != '0' && this.registro.STATUS != null
    }
  },
  watch: {
    'registro.OP_TIPO'  : function() {
      if (this.registro.OP_TIPO == '0' && this.registro.ABATE_ID) {
        this.registro.ABATE_ID = -1 // limpar o campo ordem de abate
      }
    }
  }
}
</script>


<style scoped>
.transition-hover {
  transition: all 0.3s ease;
}
.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}
.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}
.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/producao/resumoabate/ResumoAbateCadastro.vue